import { render, staticRenderFns } from "./videoAdd.vue?vue&type=template&id=24c80bda&"
import script from "./videoAdd.vue?vue&type=script&lang=js&"
export * from "./videoAdd.vue?vue&type=script&lang=js&"
import style0 from "./videoAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports